import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Paste.svg",
  "use": "Paste.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Paste.svg\"><path d=\"M21.0207,18.0208a1,1,0,0,1-1-1v-5a2,2,0,0,1,2-2h1.5a1,1,0,0,0,.8-.4l1.8-2.4a3,3,0,0,1,2.4-1.2h7a3,3,0,0,1,2.4,1.2l1.8,2.4a1,1,0,0,0,.8.4h1.5a2,2,0,0,1,2,2v5a1,1,0,0,1-1,1Zm26-4h2a3,3,0,0,1,3,3v36a3,3,0,0,1-3,3h-34a3,3,0,0,1-3-3v-36a3,3,0,0,1,3-3h2a1,1,0,0,1,1,1v2a3,3,0,0,0,3,3h22a3,3,0,0,0,3-3v-2A1,1,0,0,1,47.0207,14.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol